// extracted by mini-css-extract-plugin
module.exports = {"indicator":"Loader_indicator__a7Uix","transparentToOpaque":"Loader_transparentToOpaque__eS1cp"};